export default "__VITE_ASSET__WfXDhYj1__"